import { useSelector } from 'react-redux';

import { useProcessing } from 'hooks/useProcessing';

import { SUBSCRIPTIONS_EXTENSION_SUMMARY_LOADING_PROCESSING } from '../../../../store/redux-slices/processes/constants';
import SummaryContainer from '../../../../styledComponents/SummaryContainer/SummaryContainer';
import { ProductType } from '../../../../models/ProductType';
import { tlSubscriptionExtensionSummarySelector } from '../../../../store/redux-slices/subscriptions/travelLicense/selectors';
import ExtendTLSubscriptionSummaryContent from './ExtendTLSubscriptionSummaryContent/ExtendTLSubscriptionSummaryContent';

interface IExtendTLSubscriptionSummaryFormProps {
  disabled?: boolean;
  title?: string;
  isPriceOverridden?: boolean;
}

const ExtendTLSubscriptionSummaryForm = ({
  disabled,
  title,
  isPriceOverridden,
}: IExtendTLSubscriptionSummaryFormProps) => {
  const summaryData = useSelector(tlSubscriptionExtensionSummarySelector);
  const summaryIsLoading = useProcessing(
    SUBSCRIPTIONS_EXTENSION_SUMMARY_LOADING_PROCESSING,
  );

  return (
    <SummaryContainer
      content={() =>
        summaryData && (
          <ExtendTLSubscriptionSummaryContent
            isPriceOverridden={isPriceOverridden}
            disabled={disabled}
            productType={ProductType.TravelLicense}
            subtotalValue={summaryData.calculatedAmount}
            summaryData={summaryData}
          />
        )
      }
      data={{ totalAmount: summaryData ? summaryData.totalAmount : 0 }}
      disabled={disabled}
      isLoading={summaryIsLoading}
      title={title}
      canOverwriteAmount={false}
    />
  );
};

export default ExtendTLSubscriptionSummaryForm;
